// tslint:disable:max-line-length

import React from 'react';

export const ActionExport = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="9.5,5 6.5,5 6.5,11 3,11 8,16 13,11 9.5,11" />
      <polygon points="0,0 0,8 2,8 2,2 14,2 14,8 16,8 16,0" />
    </svg>
  );
};
